<template>
  <div>
    <div  v-if="products.length > 0"
      class="stock-warning-modal text-center"
    >
      <span class="warning-icon">
        <img src="/img/warning.png" alt="warning" />
      </span>
      <h2>Out of stock</h2>
      <p>
        The following styles are out of stock and cannot be delivered to the
        customer.
      </p>

      <div class="products-wrapper flex flex-wrap justify-content-center">
        <div
          v-for="product in products"
          :key="product.id"
          class="relative very-small-margin"
        >
          <product
            :product="product"
            :in-box="true"
            :isOutOfStock="true"
          />
          <div class="btn-remove">
            <button class="bg-pink btn btn-lg" @click="$emit('remove', product.variantId)">Remove</button>
          </div>
        </div>
      </div>

      <div class="buttons margin-top">
        <button class="bg-dark-blue flex margin-auto" @click="$emit('close')">
          <SvgFile name="back" color="#fff" size="12" />
          <span class="small-margin-left">Go Back</span>
        </button>
      </div>
    </div>
    <div v-else
      class="stock-check-modal text-center"
    >
      <span class="check-icon">
        <img src="/img/available.png" alt="available" style="margin-top: 10px"/>
      </span>
      <h2 class="available">All Available</h2>

      <div class="buttons margin-top">
        <button class="bg-dark-blue flex margin-auto" @click="$emit('close')">
          <SvgFile name="back" color="#fff" size="12" />
          <span class="small-margin-left">Go Back</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Product from './Product.vue'

let loader
export default {
  name: 'StockWarningModal',
  props: {
    products: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Product
  }
}
</script>

<style lang="less" scoped>
.stock-warning-modal {
  .warning-icon {
    display: block;
    position: absolute;
    width: 50px;
    height: 50px;
    padding: 10px;
    border-radius: 50%;
    background: #F2F2F2;
    line-height: 60px;
    border: 2px solid #FFF;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 120;
  }

  .btn-remove {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }

  .buttons {
    button {
      border-radius: 6px;
      box-shadow: 0px 3px 6px 0px rgba(0,0,0,.2);
    }
  }
}
.stock-check-modal {
  .check-icon {
    display: block;
    position: absolute;
    width: 50px;
    height: 50px;
    padding: 10px;
    border-radius: 50%;
    background: #F2F2F2;
    line-height: 60px;
    border: 2px solid #FFF;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .available {
    margin-top: 100px;
    color: #5cae62
  }

  .buttons {
    button {
      margin-top: 100px;
      border-radius: 6px;
      box-shadow: 0px 3px 6px 0px rgba(0,0,0,.2);
    }
  }
}
</style>
